import { Component, OnInit } from "@angular/core";
import moment from "moment/moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AbsencesService } from "../../../../auth/service/absences.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { WorkdayReportService } from "../../workday-report.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../i18n/it";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAbsenceType } from "app/auth/models/absences";

@Component({
  selector: "app-archive-report-view",
  templateUrl: "./archive-report-view.component.html",
  styleUrls: ["./archive-report-view.component.scss"],
})
export class ArchiveReportViewComponent implements OnInit {
  public contentHeader: IContentHeader;
  public lastDayCurrentMonth: any = null;
  public newReport: any = { days: {} }; //Sarà contenuto il report generato e anche quello caricato(sia dall'utente che da parte della visualizzazione dello staff
  public available_working_days: Array<number> = [];
  public totalWorkedHours: number = 0;
  public totalNotWorkedHours: number = 0;
  public totalExtraHours: number = 0;
  public daysOfTheMonth: any = [];
  public absence: any = []; //Contiene le assenze dell'utente
  public reportMonthAndYear: any; //Il mese e anno del report selezionato
  public categoriesAbsencesList: any = [];
  public previousExtraHours: number = 0;
  public previousExtraType: number = null;
  public previousReports: any = null; //Oggetto che viene sovrascritto nel casto di un get di un report o quando l'utente accede e ha un report già salvato a database
  public today: any = /*"30-03-2023"*/ moment().format("DD-MM-YYYY");
  public idReport: number = null; //Variabile fillata solo nel caso il report sia salato a database
  public statusReport: number = -1;
  public myProfile: any;
  public userStartWorkingInTheCurrentMonth: boolean = false;
  public contractStartDay: number = 0;
  public reportMonth: any = null;
  public reportYear: any = null;
  public checkOpenEditExtraHours: boolean = false;

  constructor(
    public _utilService: UtilsService,
    public _absenceService: AbsencesService,
    public _authenticationService: AuthenticationService,
    public _workdayReport: WorkdayReportService,
    private activatedRoute: ActivatedRoute,
    public _routerService: Router,
    public _modalService: NgbModal,
    public _userService: UserService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      this.reportMonth = String(params.month);
      this.reportYear = String(params.year);
      if (this.reportMonth > 12 || this.reportMonth < 0) {
        await this._routerService.navigateByUrl("/dashboard/main");
        return false;
      }
      if (this.reportYear > moment().year()) {
        await this._routerService.navigateByUrl("/dashboard/main");
        return false;
      }
      if (this.reportYear == moment().year() && this.reportMonth > moment().month() + 1) {
        await this._routerService.navigateByUrl("/dashboard/main");
        return false;
      }

      this.lastDayCurrentMonth = moment(`${this.reportYear}-${this.reportMonth.padStart(2, "0")}-01T22:00:00.000Z`, "YYYY-MM-DD")
        .endOf("month")
        .format("DD");
      this.reportMonthAndYear = moment()
        .month(this.reportMonth - 1)
        .format("MMMM YYYY");
    });
    this.activatedRoute.params.subscribe(async (params) => {
      if (params.hasOwnProperty("id")) {
        //Se è presente un id il report risulta a database e quindi non dobbiamo generarlo
        this.idReport = Number(params.id);
      }
      if (!this.idReport) {
        const sixMonthAgo = moment().subtract(6, "month").format("YYYY-MM");
        if (sixMonthAgo > moment(`${this.reportYear}-${this.reportMonth.padStart(2, "0")}-01T22:00:00.000Z`).format("YYYY-MM")) {
          await this._routerService.navigateByUrl("/dashboard/main");
          return false;
        }
      }
    });
    this.contentHeader = {
      headerTitle: italian.data.MENU.YOUR_WORKDAY_REPORT,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.YOUR_WORKDAY_REPORT,
            isLink: false,
          },
        ],
      },
    };

    this.available_working_days = this._utilService.themeConfiguration.working_days; //Parametro gestito da configurazione per i giorni lavorativi
  }

  async ngOnInit() {
    if (this.idReport) {
      //Se ce l'id andremo a prendere il report dal database con una get
      /*this.previousReports = await this._workdayReport.get(this.idReport)*/
      this.previousReports = await this._workdayReport.getMineReports();
      this.previousReports = this.previousReports.find((report) => report.id === this.idReport);
      if (!this.previousReports) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "WORKDAY_REPORT_NOT_FOUND" });
        await this._routerService.navigateByUrl("/dashboard/workday-report/my-archive");
        return false;
      }
      this.statusReport = this.previousReports.status;
    }
    this.myProfile = await this._userService.getMe();
    if (this.myProfile.role === "Collaboratore") {
      this._utilService.hideLoading();
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    this.categoriesAbsencesList = await this._workdayReport.getCategoriesList();
    this.absence = await this._absenceService.getMineAbsences();
    this.absence = this.absence.filter(
      (
        absence, //Prendiamo le assenze per il mese selezionato
      ) => moment(absence.from).format("MM/YYYY") === String(this.reportMonth + "/" + this.reportYear) && absence.status === 1,
    );
    await this.selectReport();
    this._utilService.hideLoading();
  }

  /*Funzione che sceglie se generare un report nel caso non vi siano report salvati a database per il periodo corrente, oppure se presente carica il report del database*/
  async selectReport() {
    if (this.previousReports) {
      await this.loadReport(); //Abbiamo trovato il report salvato quindi carichiamo quello
    }
    if (!this.previousReports) {
      await this.generateNewReport(); //Non vi sono report salvati quindi generiamo
    }
  }

  async loadReport() {
    this.totalExtraHours = 0;
    this.totalWorkedHours = 0;
    this.totalNotWorkedHours = 0;
    if (moment(this.myProfile.contract_start_date).format("MM-YYYY") == moment(`${this.reportYear}-${this.reportMonth.padStart(2, "0")}-01T22:00:00.000Z`, "YYYY-MM-DD").format("MM-YYYY")) {
      this.userStartWorkingInTheCurrentMonth = true;
      this.contractStartDay = Number(moment(this.myProfile.contract_start_date).format("D"));
    }
    this.newReport.days = this.previousReports.report;
    this.daysOfTheMonth = Object.keys(this.newReport.days);

    this.daysOfTheMonth.forEach((day) => {
      //Ci prendiamo il nome delle categorie delle ore extra se l'utente ha inserito delle ore extra
      if (this.newReport.days[day].extra.type_id > 0) {
        let category = this.categoriesAbsencesList.find((c) => c.id === this.newReport.days[day].extra.type_id);
        this.newReport.days[day].type_name = category.name;
      }
    });
    //Calcolo ore totali di lavoro
    this.daysOfTheMonth = Object.keys(this.newReport.days);
    Object.values(this.newReport.days).map((item: any) => {
      this.totalWorkedHours += Number(item.working_hours || 0);
    });
    //Calcolo ore totali non lavorative
    Object.values(this.newReport.days).map((item: any) => {
      item.absences.map((absence: any) => {
        this.totalNotWorkedHours += Number(absence.hours || 0);
      });
    });
    //Calcolo ore extra
    Object.values(this.newReport.days).map((item: any) => {
      this.totalExtraHours += Number(item.extra.hours || 0);
    });
  }

  async generateNewReport() {
    let holidayNationalAbsence: IAbsenceType[] | IAbsenceType = await this._absenceService.getTypeList();
    holidayNationalAbsence = holidayNationalAbsence.find((code) => code.code === "F1");
    /**
     * All'avvio della funzione resetto tutte le variabili
     */
    this.totalWorkedHours = 0;
    this.totalNotWorkedHours = 0;
    this.totalExtraHours = 0;
    this.newReport = { days: [] };
    this.previousReports = null;
    ///////////////////////////////
    /**
     * Per ogni giorno del mese corrente effettuiamo un for e andremo a fillare newReport con chiavi
     * dei giorni del mese corrente e setteremo come chiavi Working_hours e absences vuoto per ora (andremo a fillarlo dopo)
     * controlliamo anche se un utente inizia nel mese corrente
     */
    if (moment(this.myProfile.contract_start_date).format("MM-YYYY") == moment(`${this.reportYear}-${this.reportMonth.padStart(2, "0")}-01T22:00:00.000Z`, "YYYY-MM-DD").format("MM-YYYY")) {
      this.userStartWorkingInTheCurrentMonth = true;
      this.contractStartDay = Number(moment(this.myProfile.contract_start_date).format("D"));
    }
    for (let i = 1; i <= this.lastDayCurrentMonth; i++) {
      const currentDate = moment(`${this.reportYear}-${this.reportMonth.padStart(2, "0")}-${i}T22:00:00.000Z`, "YYYY-MM-D");
      let workingHours: number = this.available_working_days.includes(Number(currentDate.format("d"))) ? 8 : 0;
      workingHours = this._utilService.isHoliday(currentDate) ? 0 : workingHours;

      const workdayElement: any = {
        category: holidayNationalAbsence.type,
        code: holidayNationalAbsence.code,
        hours: 0,
        name: holidayNationalAbsence.name,
      };

      this.newReport.days[currentDate.format("YYYY-MM-DD")] = Object.assign({
        working_hours: this.userStartWorkingInTheCurrentMonth && Number(currentDate.format("D")) < this.contractStartDay ? 0 : workingHours,
        absences: this._utilService.isHoliday(currentDate) && this.available_working_days.includes(Number(currentDate.format("d"))) && Number(currentDate.format("D")) > this.contractStartDay ? [workdayElement] : [],
        extra: { hours: 0, type_id: null },
        extra_km: 0,
        extra_payroll: 0,
        type_name: null,
        addExtraHours: false,
      });
    }
    this.daysOfTheMonth = Object.keys(this.newReport.days); /*Array contenente tutti i giorni del mese*/
    ////////////////////////////////////////////////////////////////////////

    if (this.absence) {
      /*Se sono presenti assenze andremo a ciclarle e a inserirle in newReport*/
      this.absence.map((item: any) => {
        const absenceDate: any = moment(item.from.split("T")[0]);
        if (!absenceDate || !absenceDate.isValid) return;

        const reportItem: any = this.newReport.days[absenceDate.format("YYYY-MM-DD")];

        const from: any = moment(item.from);
        const to: any = moment(item.to);

        if (item.type.category === "permesso") {
          let difference: number = to.diff(from, "minutes");
          difference = difference / 60;
          //Controllo per la pausa pranzo nel caso dalla differenza togliamo un ora
          if (from.hours() >= 9 && from.hours() <= 13 && to.hours() >= 14 && to.hours() <= 18) {
            difference = difference - 1;
          }
          reportItem.working_hours = reportItem.working_hours - (difference > 8 ? 8 : difference);
          if (reportItem.working_hours < 0) {
            reportItem.working_hours = 0;
          }
          reportItem.absences.push({
            hours: difference,
            code: item.type.code,
            name: item.type.name,
            category: item.type.category,
          });
        } else {
          reportItem.working_hours = 0;
          reportItem.absences.push({
            hours: 8,
            code: item.type.code,
            name: item.type.name,
            category: item.type.category,
          });
          const difference: number = to.diff(from, "days");

          for (let i = 1; i <= difference; i++) {
            absenceDate.add(1, "days");
            const newReport: any = this.newReport.days[absenceDate.format("YYYY-MM-DD")];
            //Se l'assenza è una malattia andremo a inserirla anche nei giorni festivi e weekend
            if (item.type.category !== "ferie") {
              newReport.working_hours = 0;
              newReport.absences.push({
                hours: 8,
                code: item.type.code,
                name: item.type.name,
                category: item.type.category,
              });
            } else {
              //Escludiamo i weekend o i giorni festivi nazionali controllando che le ore lavorative sono maggiori di zero
              if (newReport && newReport.working_hours > 0) {
                newReport.working_hours = 0;
                newReport.absences.push({
                  hours: 8,
                  code: item.type.code,
                  name: item.type.name,
                  category: item.type.category,
                });
              }
            }
          }
        }
      });
    }

    //Calcolo ore totali di lavoro
    this.daysOfTheMonth = Object.keys(this.newReport.days);
    Object.values(this.newReport.days).map((item: any) => {
      this.totalWorkedHours += item.working_hours;
    });
    //Calcolo ore totali non lavorative
    Object.values(this.newReport.days).map((item: any) => {
      item.absences.map((absence: any) => {
        this.totalNotWorkedHours += absence.hours;
      });
    });
    //Calcolo ore extra
    Object.values(this.newReport.days).map((item: any) => {
      this.totalExtraHours += item.extra.hours;
    });
  }

  //Funzione per gestire i colori della visualizzazione della lista
  isWorkDay(day: string) {
    const dayN: number = Number(moment(day).format("d"));
    return this.available_working_days.includes(dayN);
  }

  //Funzione invio report che avrà status uno e quindi lo staff potrà visualizzarlo e decidere se approvare o rifiutare
  async sendReport() {
    if (this.checkOpenEditExtraHours) {
      await this._utilService.showSWALError({ text: "SAVE_FIRST_EXTRA_HOUR" });
      return false;
    }
    const data: any = {
      report: { ...this.newReport.days },
      status: 1,
    };
    this._utilService.showLoading();
    await this._workdayReport
      .sendReport(data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_WORKDAY_REPORT" });
        await this._routerService.navigateByUrl("/dashboard/workday-report/my-archive");
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_SEND_WORKDAY_REPORT" });
      });
  }

  //Funzione per modificare il report che è già presente nel database in caso di rifiuto
  async updateReport() {
    if (this.checkOpenEditExtraHours) {
      await this._utilService.showSWALError({ text: "SAVE_FIRST_EXTRA_HOUR" });
      return false;
    }
    const data: any = {
      report: { ...this.newReport.days },
      status: 1,
    };
    this._utilService.showLoading();
    await this._workdayReport
      .update(this.idReport, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_WORKDAY_REPORT" });
        await this._routerService.navigateByUrl("/dashboard/workday-report/my-archive");
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_WORKDAY_REPORT" });
      });
  }

  /*Apre la modifica del giorno singolo per le ore extra*/
  async openEditExtraHoursDiv(selectedDay: any) {
    let thereIsAnEditOpen: any; /*Controllo per capire se ci sono giornate aperte in edit*/
    this.daysOfTheMonth.map((day: any) => {
      if (this.newReport.days[day].addExtraHours) {
        return (thereIsAnEditOpen = true);
      }
    });
    if (thereIsAnEditOpen > 0) {
      /*Se c'è una giornata in edit chiediamo all'utente di salvare o cancellare le ore extra per il giorno selezionato prima di poter aprire un altro edit*/
      await this._utilService.showSWALError({ text: "SAVE_FIRST_EXTRA_HOUR" });
      return false;
    }
    this.newReport.days[selectedDay].addExtraHours = true;
    //A ogni apertura salvo i valori che sono inseriti cosi da poter gestire l'annulla e riportare i dati a come erano stati inseriti
    this.previousExtraHours = this.newReport.days[selectedDay].extra.hours;
    this.previousExtraType = this.newReport.days[selectedDay].extra.type_id;
    this.checkOpenEditExtraHours = true;
  }

  /*Salvataggio per il singolo giorno delle ore extra*/
  async saveExtraHourEdit(day: any) {
    if (this.newReport.days[day].extra.hours > 12) {
      await this._utilService.showSWALError({ text: "TO_MANY_HOURS" });
      return false;
    }
    this.totalExtraHours = 0;
    this.daysOfTheMonth.map((item: any) => {
      return (this.totalExtraHours += this.newReport.days[item].extra.hours);
    });
    let category = this.categoriesAbsencesList.find((c) => c.id === this.newReport.days[day].extra.type_id);
    this.newReport.days[day].type_name = category.name;
    this.newReport.days[day].addExtraHours = false;
    this.previousExtraType = null;
    this.previousExtraHours = 0;
    this.checkOpenEditExtraHours = false;
  }

  /*Annulla per il singolo giorno delle ore extra riporta i dati a quelli precedentemente inseriti dall'utente*/
  cancelExtraHour(day) {
    this.newReport.days[day].extra.hours = this.previousExtraHours;
    this.newReport.days[day].extra.type_id = this.previousExtraType;
    this.newReport.days[day].addExtraHours = null;
    this.previousExtraType = null;
    this.previousExtraHours = 0;
    this.checkOpenEditExtraHours = false;
  }

  /*Cancella per il singolo giorno delle ore extra riporta i dati a zero o a null come se l'utente non avesse inserito nulla*/
  deleteExtraHour(day: any) {
    this.newReport.days[day].addExtraHours = null;
    this.newReport.days[day].extra.hours = 0;
    this.newReport.days[day].extra.type_id = null;
    this.newReport.days[day].type_name = null;
    this.previousExtraType = null;
    this.previousExtraHours = 0;
    this.totalExtraHours = 0;
    this.daysOfTheMonth.map((item: any) => {
      return (this.totalExtraHours += this.newReport.days[item].extra.hours);
    });
    this.checkOpenEditExtraHours = false;
  }
}
